import { mapActions, mapGetters, mapMutations } from "vuex";
import { secondsToTimecode, timecodeToSeconds } from "../../../utils";
import { ASCENDING, DESCENDING, LATEST, OLDEST } from "../../sorting_algos";
import { GET_STARTED_STEPS } from "../constant";
import SuiteAppUtils from "../../utils.suite-app";
export const MEDIAME_MODULE_NAME = "mediame";
import { PROJECT_MODULE_NAME } from "../../Project/store/project.vuex";

export const MEDIAME_MODAL_ACTIONS = {
  UPLOAD: "UPLOAD",
  ADD_TAG: "ADD_TAG",
  EDIT_TAG: "EDIT_SMART_TAG",
  EMAIL_MEDIA: "EMAIL_MEDIA",
  UPDATE_USER_NAME: "UPDATE_USER_NAME",
  MEDIA_INFO: "MEDIA_INFO",
  GET_STARTED: "GET_STARTED",
  ADD_PROJECT: "ADD_PROJECT",
  STUDIO_SESSION: "STUDIO_SESSION",
  MEDIAME_AI: "MEDIAME_AI",
  NEW_USER_BETA_FEATURES: "NEW_USER_BETA_FEATURES",
  PREFERENCES: "PREFERENCES",
};

const SOURCE = {
  DeliverME: "deliver_me",
  DirectME: "direct_me",
  MediaME: "media_me",
};

export const MEDIAME_SORT_OPTIONS = {
  ascending: { title: "Ascending [A->Z]", algo: ASCENDING },
  descending: { title: "Descending [Z->A]", algo: DESCENDING },
  oldest: { title: "Oldest", algo: OLDEST },
  latest: { title: "Most Recent", algo: LATEST },
};

export const MAX_GET_STARTED_ACTIONS = 20;

const DEFAULT_ITEMS_PER_PAGE = 16;

let __takePlayer = null;

const initState = {
  is_connected: false,
  is_new_user: false,

  media_list: [],
  media: null,
  favorites: [],
  filesBeingUploaded: [],

  tags_list: [],
  tags_list_with_id: [],

  modal: null,

  upload_waitlist: [],
  uploadedFiles: [],
  visibility: "Everyone",

  selectedMedia: [],
  videoPlayerTime: 0,

  isLoading: { index: false, load_media: false },

  query: "",
  appliedFilter: "All",
  sort: "ascending",
  type: "all",

  activeTab: "media",
  localStorageFavKey: null,

  startIndex: 0,
  perPage: DEFAULT_ITEMS_PER_PAGE,
  endIndex: DEFAULT_ITEMS_PER_PAGE - 1,
  currentPage: 1,
  //favorites: [],

  get_started_actions_performed: [],
  get_started_metadata: { transcribe_id: null, upload_id: null },
  get_started_current_step: GET_STARTED_STEPS.STEP_1,
  get_started_selected_preferences: [],
  get_started_selected_preference_categories: [],

  video_player_container__clappr: null,
  selected_clip_id: "original",
};

const add_reply = (logs, log) => {
  logs.forEach((l) => {
    if (l.id === log.parent_log_id) {
      l.replies.push(log);
      l.replies.sort((a, b) => a.timecode_in - b.timecode_in);
    } else {
      add_reply(l.replies, log);
    }
  });
};

const update_reply = (replies, log) => {
  replies.forEach((reply, index) => {
    if (reply.id === log.id) {
      replies.splice(index, 1, log);
    } else {
      update_reply(reply.replies, log);
    }
  });
};

const delete_reply = (replies, params) => {
  replies.forEach((log) => {
    if (log.id === params.parent_log_id && log.replies) {
      const index = log.replies.findIndex((reply) => reply.id === params.id);
      if (index > -1) {
        log.replies.splice(index, 1);
      } else {
        delete_reply(log.replies, params);
      }
    } else {
      delete_reply(log.replies, params);
    }
  });
};

const createClipMarkersInfo = (clip) => {
  let markerInfo = {};
  if (!clip.has_parent_clip) return null;

  const { start_time, end_time } = clip.trimmed_clip_metadata;
  const hashid = clip.hashid;

  markerInfo = {
    id: hashid,
    start_time: start_time,
    end_time: end_time,
    label: clip.name,
    color: "#FF0338",
    select_color: "#0CFDD1",
  };

  return markerInfo;
};

/**
 * Assigns timecode to the given log and its replies
 *
 * @param {Object} log - The log object to assign timecode to
 * @param {number} offset - The offset in seconds to apply to the timecode
 * @returns {Object} - The assigned log object
 */
const assign_tc = (log, offset, frame_rate) => {
  // Handle both float and timecode string formats
  const timecode_in =
    typeof log.timecode_in === "number" ? log.timecode_in : timecodeToSeconds(log.timecode_in, frame_rate);

  log.start_timecode = secondsToTimecode(offset, timecode_in, frame_rate);
  log.replies
    .sort((a, b) => {
      const a_tc = typeof a.timecode_in === "number" ? a.timecode_in : timecodeToSeconds(a.timecode_in, frame_rate);
      const b_tc = typeof b.timecode_in === "number" ? b.timecode_in : timecodeToSeconds(b.timecode_in, frame_rate);
      return a_tc - b_tc;
    })
    .map((l) => assign_tc(l, offset, frame_rate));
  return log;
};

const MediaMEModule = {
  namespaced: true,
  state: () => initState,
  mutations: {
    // COMMON
    RESET(state) {
      state.is_connected = false;
      state.media = null;
      state.modal = null;
      state.media_list = [];
    },
    connected(state, flag) {
      state.is_connected = flag;
    },

    //LIST Media
    index(state, { body: data, params }) {
      let items = [];
      items = [...(data.videos || []), ...(data.clips || []), ...(data.broadcast_recordings || [])];
      items.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

      // figure out all unique tags from list of medias
      let tags = {};
      let tags_with_id = [];
      const unique_key = "id";

      items.forEach((item) => {
        //Change type to audio if ends in .mp3 or .wav
        if (item?.name?.endsWith(".mp3") || item?.name?.endsWith(".wav")) item.type = "audio";

        item.tag_list.forEach((tag) => {
          tags[tag] = 0;
        });
        tags_with_id = [...tags_with_id, ...item.tag_obj];
      });
      state.tags_list = Object.keys(tags);
      state.tags_list_with_id = [...new Map(tags_with_id.map((e) => [e[unique_key], e])).values()];

      state.media_list = items;

      state.isLoading.index = false;
      //Add Tag List with id as well
    },

    load_media(state, { body: items, params }) {
      SuiteAppUtils.sleep(1);
      items.forEach((item) => {
        const index = state.media_list.findIndex((media) => {
          return media.hashid && item.hashid && media.hashid === item.hashid && media.belongs_to === item.belongs_to;
        });
        if (index > -1) {
          state.media_list.splice(index, 1, { ...state.media_list[index], ...item, url_checked: true });
        }
      });

      state.isLoading.load_media = false;
    },
    destroy(state, { params }) {
      state.media_list = state.media_list.filter((media) => media.hashid !== params.hashid);
    },
    create_log(state, { body: log, params }) {
      if (state.media) {
        if (!(state.media.hashid === params.hashid && state.media.belongs_to === params.belongs_to)) {
          return;
        }

        log = assign_tc(log, state.media.offset, state.media.frame_rate);
        if (params.parent_log_id) {
          add_reply(state.media.logs, log);
        } else {
          state.media.logs.push(log);
          state.media.logs.sort((a, b) => a.timecode_in - b.timecode_in);
        }
      }
    },
    update_log(state, { body: log, params }) {
      if (state.media) {
        if (!(state.media.hashid === params.hashid && state.media.belongs_to === params.belongs_to)) {
          return;
        }

        log = assign_tc(log, state.media.offset, state.media.frame_rate);
        if (params.parent_log_id) {
          update_reply(state.media.logs, log);
        } else {
          const index = state.media.logs.findIndex((l) => l.id === params.id);
          if (index !== -1) {
            state.media.logs.splice(index, 1, log);
          }
        }
      }
    },

    destroy_log(state, { params }) {
      if (state.media) {
        if (!(state.media.hashid === params.hashid && state.media.belongs_to === params.belongs_to)) {
          return;
        }

        if (params.parent_log_id) {
          delete_reply(state.media.logs, params);
        } else {
          const index = state.media.logs.findIndex((l) => l.id === params.id);
          if (index > -1) {
            state.media.logs.splice(index, 1);
          }
        }
      }
    },

    // create media upload
    create(state, { body: payload, params }) {
      console.log("Create Action In MediaME Store", payload, params);
      if (payload) {
        payload.forEach((p) => state.media_list.unshift(p));
      }
      const uploaded_file_ids = params.files.map((p, index) => {
        return { hashid: payload[index].hashid, belongs_to: payload[index].belongs_to };
      });

      state.get_started_metadata.upload_id = uploaded_file_ids;
    },

    show(state, { body }) {
      /*   if (state.media && body) {
        console.log("Case 1");

        if (!(state.media.hashid === body.hashid && state.media.belongs_to === body.belongs_to)) {
          console.log("Case 2");
          return;
        }
      } */
      if (body) {
        console.log("Case 3");
        if (body.timecode_in && body.frame_rate) {
          body.offset = timecodeToSeconds(body.timecode_in, body.frame_rate);
        }
        body.logs = body.logs
          .sort((a, b) => a.timecode_in - b.timecode_in)
          .map((l) => assign_tc(l, body.offset, body.frame_rate));

        body.transcriptions = body.transcriptions.map((t) => {
          t.start_seconds = timecodeToSeconds(t.start_time, body.frame_rate) - body.offset;
          return t;
        });
        body.transcriptions.sort((a, b) => a.start_seconds - b.start_seconds);
        // if media is present then ignore below from body
        if (state.media) {
          body.locations_list = state.media.locations_list;
          body.casts_list = state.media.casts_list;
          // body.transcriptions = state.media.transcriptions;
          body.logs = state.media.logs;
          body.casts = state.media.casts;
        }

        if (body?.name?.endsWith(".mp3") || body?.name?.endsWith(".wav")) body.type = "audio";
      }

      const body_copy = { ...body };
      if (body_copy.trimmed_clips && body_copy.trimmed_clips.length > 0) {
        body_copy.trimmed_clips.forEach((clip) => {
          const markerInfo = createClipMarkersInfo(clip);
          if (markerInfo) clip.markerInfo = markerInfo;
        });
      }

      state.media = body_copy;
      state.selected_clip_id = "original";
    },

    update(state, { body, params }) {
      const index = state.media_list.findIndex((m) => m.hashid === params.hashid && m.belongs_to === params.belongs_to);
      if (index > -1) {
        state.media_list.splice(index, 1, { ...state.media_list[index], ...body });
      }
    },

    create_tag(state, { body: new_tag, params }) {
      params.items.forEach((item) => {
        const index = state.media_list.findIndex(
          (media) => media.hashid === item.hashid && media.belongs_to === item.belongs_to
        );
        if (index > -1) {
          state.media_list[index].tag_list.unshift(params.tag_content);
          //add tag to tag_obj if not already exist
          const is_tag_in_tag_obj = state.media_list[index].tag_obj.find(
            (each_tag_obj) => each_tag_obj.id === new_tag.id
          );
          if (!is_tag_in_tag_obj) state.media_list[index].tag_obj.unshift(new_tag);
        }
      });

      //Add tag to tag_list_with_id if not already present
      const tag_index = state.tags_list_with_id.findIndex((each_tag) => each_tag.id === new_tag.id);
      if (tag_index === -1) state.tags_list_with_id = [...state.tags_list_with_id, new_tag];
    },
    destroy_tag(state, { params }) {
      params.items.forEach((item) => {
        const index = state.media_list.findIndex(
          (media) => media.hashid === item.hashid && media.belongs_to === item.belongs_to
        );
        if (index > -1) {
          const tag_index = state.media_list[index].tag_list.findIndex((tag) => tag === params.tag_content);
          if (tag_index > -1) {
            state.media_list[index].tag_list.splice(tag_index, 1);
          }
        }
      });

      const isTagUsed = state.media_list.some((media) => media.tag_list.includes(params.tag_content));
      if (!isTagUsed) {
        const tagIndex = state.tags_list.findIndex((tag) => tag === params.tag_content);
        if (tagIndex > -1) {
          state.tags_list.splice(tagIndex, 1);
        }
      }
    },
    updateSpeakerLabel(state, payload) {
      if (state.media) {
        if (!(state.media.hashid === payload.hashid && state.media.belongs_to === payload.belongs_to)) {
          return;
        }

        const transcriptIndex = state.media.transcriptions.findIndex((transcript) => transcript.id === payload.id);
        if (transcriptIndex !== -1) {
          const oldLabel = state.media.transcriptions[transcriptIndex].speaker_label;

          // Update the speaker_label in all objects where it matches the old label
          state.media.transcriptions.forEach((transcript) => {
            if (transcript.speaker_label === oldLabel) {
              transcript.speaker_label = payload.speaker_label;
            }
          });
        }
      }
    },
    update_tran_speaker_label(state, { params, body }) {
      if (state.media) {
        if (!(state.media.hashid === params.hashid && state.media.belongs_to === params.belongs_to)) {
          return;
        }

        if (params.is_all) {
          // Update the speaker_label in all objects where it matches the old label
          state.media.transcriptions.forEach((transcript) => {
            if (transcript.speaker_label === body.old_speaker_label) {
              transcript.speaker_label = params.speaker_label;
            }
          });
        } else {
          const index = state.media.transcriptions.findIndex((t) => t.id === params.id);
          if (index > -1) {
            state.media.transcriptions[index].speaker_label = params.speaker_label;
          }
        }
      }
    },
    create_clip_metadata(state, { body }) {
      if (body.ai_metadata_status === "failure") {
        return console.error("AI Metadata Generation Failed");
      }

      const mediaIndex = state.media_list.findIndex((m) => m.hashid === body.hashid);

      if (mediaIndex !== -1) {
        state.media_list[mediaIndex] = {
          ...state.media_list[mediaIndex],
          ai_metadata: {
            ai_data: body?.ai_metadata?.ai_data,
            selected_data: {
              titles: null,
              descriptions: null,
              tags: null,
            },
          },
          ai_metadata_status: body.ai_metadata_status,
        };
      }

      if (state.media?.hashid === body.hashid) {
        state.media = {
          ...state.media,
          ai_metadata: {
            ai_data: body?.ai_metadata?.ai_data,
            selected_data: {
              titles: null,
              descriptions: null,
              tags: null,
            },
          },
          ai_metadata_status: body.ai_metadata_status,
        };
      }
    },
    create_trimmed_clips(state, { body }) {
      const mediaIndex = state.media_list.findIndex((m) => m.hashid === body.hashid);
      if (mediaIndex !== -1) {
        const newObjAtIndex = {
          ...state.media_list[mediaIndex],
          ...body,
        };
        state.media_list = state.media_list.splice(mediaIndex, 1, newObjAtIndex);
        state.media = state.media_list.find((m) => m.hashid === body.hashid);

        console.log("create_trimmed_clips: state.media", state.media);
        console.log("create_trimmed_clips: state.media_list", state.media_list);
      }
    },
    fetch_trimmed_clips_generation_status(state, { body }) {
      const mediaIndex = state.media_list.findIndex((m) => m.hashid === body.hashid);
      if (mediaIndex !== -1) {
        const newObjAtIndex = {
          ...state.media_list[mediaIndex],
          ...body,
        };
        state.media_list = state.media_list.splice(mediaIndex, 1, newObjAtIndex);
        state.media = state.media_list.find((m) => m.hashid === body.hashid);
      }
    },
    update_clip_metadata(state, { body = {}, params }) {
      // Safely extract values with optional chaining
      const selectedTitle = body?.ai_metadata?.selected_data?.titles;
      const descriptions = body?.ai_metadata?.selected_data?.descriptions || {};
      const { short, medium, long } = descriptions;

      const updateMetadata = (target) => {
        if (!target) return;

        if (selectedTitle) target.name = selectedTitle;

        // Use the first available description, prioritizing short -> medium -> long
        target.description = short || medium || long || target.description;
      };

      // Update either the main media or the specific clip
      if (state.media.hashid === params.hashid) {
        updateMetadata(state.media);
      } else {
        const clip = state.media.trimmed_clips?.find((clip) => clip.hashid === params.hashid);
        updateMetadata(clip);
      }
    },
    show_captions(state, { body: captions }) {
      // Early return if required data is missing
      if (!state.media?.transcriptions || !captions) return;

      try {
        const timecodeToSec = createTimecodeConverter();
        const captionTimes = processCaptions(captions, timecodeToSec);

        // Process main transcriptions
        state.media.transcriptions = processMainTranscriptions(state.media.transcriptions, captionTimes, timecodeToSec);

        // Process clips if they exist
        if (state.media.trimmed_clips?.length) {
          state.media.trimmed_clips.forEach((clip) => {
            if (!clip.trimmed_clip_metadata) return;

            const clipStart = timecodeToSec(clip.trimmed_clip_metadata.start_time);
            const clipEnd = timecodeToSec(clip.trimmed_clip_metadata.end_time);

            clip.transcriptions = processClipTranscriptions(
              state.media.transcriptions,
              captionTimes,
              clipStart,
              clipEnd,
              timecodeToSec
            );
          });
        }
      } catch (error) {
        console.error("Error processing captions:", error);
        // Optionally handle the error in a way that makes sense for your application
      }
    },
    setVisibility(state, value) {
      state.visibility = value;
    },

    // command
    addUploadedFile(state, file) {
      state.uploadedFiles.push(file);
    },
    updateUploadedFile(state, data) {
      const index = state.uploadedFiles.findIndex((f) => f.id === data.id);
      if (index > -1) {
        state.uploadedFiles.splice(index, 1, { ...state.uploadedFiles[index], ...data });
      }
    },
    destroyUploadedFile(state, file) {
      const index = state.uploadedFiles.findIndex((f) => f.signed_id === file.signed_id);
      if (index > -1) {
        state.uploadedFiles.splice(index, 1);
      }
    },

    modalData(state, data) {
      state.uploadedFiles = [];
      state.modal = (typeof data === "string" ? { action: data } : data) || null;
    },
    DestroyLog(state, log) {
      this.$cable.perform({
        channel: MEDIAME_MODULE_NAME,
        action: "destroy_log",
        data: {
          hashid: state.media.hashid,
          belongs_to: state.media.belongs_to,
          id: log.id,
          log: log,
        },
      });
    },
    addSelectedMedia(state, itemArray) {
      state.selectedMedia = itemArray;
    },
    resetSelectedMedia(state) {
      state.selectedMedia = [];
    },
    setLoading(state, { action: action_name, flag = true }) {
      state.isLoading[action_name] = flag;
    },
    setSearchQuery(state, query) {
      state.query = query;
    },
    setAppliedFilter(state, appliedFilter) {
      state.appliedFilter = appliedFilter;
    },
    setSort(state, value) {
      state.sort = value;
    },
    setType(state, value) {
      state.type = value;
    },
    setPaginationData(state, params) {
      for (const key in params) if (params[key]) state[key] = params[key];
    },
    changeTab(state, new_tab_key) {
      state.activeTab = new_tab_key;
    },
    setLocalStorageFavKey(state, key) {
      state.localStorageFavKey = key;
    },
    setAsOldUser(state, flag = true) {
      state.is_new_user = !flag;
    },
    getFavorites(state) {
      state.favorites = JSON.parse(localStorage.getItem(state.localStorageFavKey));
    },
    toggleFavorite(state, media) {
      let fav_temp = [];
      if (!state.favorites) fav_temp = [media];
      else {
        const index = state.favorites.findIndex((item) => item.hashid === media.hashid);
        fav_temp = [...state.favorites];

        if (index !== -1) fav_temp.splice(index, 1);
        else fav_temp.push(media);
      }

      state.favorites = [...fav_temp];

      localStorage.setItem(state.localStorageFavKey, JSON.stringify(state.favorites));
    },
    addToUploadWaitlist(state, file) {
      state.upload_waitlist.push(file);
    },
    removeFromUploadWaitlist(state, file) {
      state.upload_waitlist = state.upload_waitlist.filter((f) => f.temp_id !== file.temp_id);
    },
    addGetStartedActionPerformed(state, action) {
      state.get_started_actions_performed = [...state.get_started_actions_performed, action];
    },
    setGetStartedMetadata(state, { key, value }) {
      state.get_started_metadata[key] = value;
    },
    setMediaTranscriptionStatus(state, { hashid, belongs_to, status }) {
      const index = state.media_list.findIndex((m) => m.hashid === hashid && m.belongs_to === belongs_to);
      if (index > -1) state.media_list[index].transcription_analysis_status = status;
    },
    setVideoPlayerTime(state, time) {
      state.videoPlayerTime = time;
    },
    setGetStartedSelectedPreferences(state, preferences) {
      state.get_started_selected_preferences = preferences;
    },
    setGetStartedSelectedPreferenceCategories(state, categories) {
      state.get_started_selected_preference_categories = categories;
    },
    goToStep(state, { step }) {
      state.get_started_current_step = step;
    },
    nextStep(state) {
      const nextStepMapping = {
        [GET_STARTED_STEPS.STEP_1_1]: GET_STARTED_STEPS.STEP_2,
        [GET_STARTED_STEPS.STEP_3_1]: GET_STARTED_STEPS.STEP_4,
        [GET_STARTED_STEPS.STEP_3]: GET_STARTED_STEPS.STEP_3_1,
        [GET_STARTED_STEPS.STEP_5]: GET_STARTED_STEPS.STEP_5,
      };

      state.get_started_current_step =
        nextStepMapping[state.get_started_current_step] || state.get_started_current_step + 1;
    },
    previousStep(state) {
      const previousStepMapping = {
        [GET_STARTED_STEPS.STEP_1]: GET_STARTED_STEPS.STEP_1,
        [GET_STARTED_STEPS.STEP_1_1]: GET_STARTED_STEPS.STEP_1,
        [GET_STARTED_STEPS.STEP_3_1]: GET_STARTED_STEPS.STEP_3,
        [GET_STARTED_STEPS.STEP_4]: GET_STARTED_STEPS.STEP_3_1,
      };

      state.get_started_current_step =
        previousStepMapping[state.get_started_current_step] || state.get_started_current_step - 1;
    },
    addFilesBeingUploaded(state, file) {
      state.filesBeingUploaded.push(file);
    },
    removeFilesBeingUploaded(state, file) {
      state.filesBeingUploaded = state.filesBeingUploaded.filter((f) => f.temp_id !== file.temp_id);
      state.media_list = state.media_list.filter((m) =>
        Object.hasOwn(m, "temp_id") ? m.temp_id !== file.temp_id : true
      );
    },
    setVideoPlayerContainer(state, __player) {
      state.video_player_container__clappr = __player;
    },
    removeVideoPlayerContainer(state) {
      state.video_player_container__clappr = null;
    },
    setSelectedClipId(state, id) {
      state.selected_clip_id = id;
    },
  },
  actions: {
    // Update the convertToWebVTT function to properly handle the transcription data
    async convertToWebVTT({ state }, transcriptionData) {
      function formatTime(seconds) {
        const pad = (num) => num.toString().padStart(2, "0");
        const hours = pad(Math.floor(seconds / 3600));
        const minutes = pad(Math.floor((seconds % 3600) / 60));
        const secs = pad(Math.floor(seconds % 60));
        const ms = pad(Math.floor((seconds % 1) * 1000)).slice(0, 3);

        return `${hours}:${minutes}:${secs}.${ms}`;
      }

      function timecodeToSeconds(timecode) {
        const [hours, minutes, seconds, frames] = timecode.split(":").map(Number);
        return hours * 3600 + minutes * 60 + seconds + frames / 30;
      }

      function splitIntoLines(text, maxCharsPerLine = 50) {
        const words = text.split(" ");
        const lines = [];
        let currentLine = [];
        let currentLength = 0;

        words.forEach((word) => {
          const wordLength = word.length + 1; // +1 for the space
          if (currentLength + wordLength > maxCharsPerLine) {
            if (currentLine.length > 0) {
              lines.push(currentLine.join(" "));
              currentLine = [];
              currentLength = 0;
            }
          }
          currentLine.push(word);
          currentLength += wordLength;
        });

        if (currentLine.length > 0) {
          lines.push(currentLine.join(" "));
        }

        return lines;
      }

      function getLineWeight(line) {
        let weight = line.length;

        // Add weight for punctuation
        if (line.match(/[.!?]$/)) {
          weight *= 1.5; // End of sentence gets more time
        } else if (line.match(/[,;:]$/)) {
          weight *= 1.2; // End of clause gets slightly more time
        }

        // Add weight for complexity
        const complexWords = line.match(/[A-Z][a-z]{8,}|[^a-zA-Z\s]{2,}/g) || [];
        weight += complexWords.length * 2;

        // Add weight for numbers and special characters
        const numbers = line.match(/\d+/g) || [];
        weight += numbers.length;

        return Math.max(weight, 1);
      }

      let vttContent = "WEBVTT\n\n";
      let cueIndex = 1;
      let lastSpeaker = null;
      let speakerJustChanged = false;

      // Group segments by speaker
      let currentGroup = [];
      let groups = [];

      transcriptionData.forEach((segment, index) => {
        if (index === 0 || segment.speaker_label !== transcriptionData[index - 1].speaker_label) {
          if (currentGroup.length > 0) {
            groups.push(currentGroup);
          }
          currentGroup = [segment];
        } else {
          currentGroup.push(segment);
        }
      });
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }

      groups.forEach((group) => {
        const currentSpeaker = group[0].speaker_label;
        const speakerChanged = currentSpeaker !== lastSpeaker;
        lastSpeaker = currentSpeaker;

        group.forEach((segment, segmentIndex) => {
          const startSeconds = segment.start_seconds;
          const endSeconds = timecodeToSeconds(segment.end_time);
          const totalDuration = endSeconds - startSeconds;

          const lines = splitIntoLines(segment.segment);
          const weights = lines.map(getLineWeight);
          const totalWeight = weights.reduce((sum, weight) => sum + weight, 0);

          let currentTime = startSeconds;

          lines.forEach((line, lineIndex) => {
            const lineWeight = weights[lineIndex];
            const lineDuration = (lineWeight / totalWeight) * totalDuration;
            const lineEndTime = currentTime + lineDuration;

            vttContent += `${cueIndex++}\n`;
            vttContent += `${formatTime(currentTime)} --> ${formatTime(lineEndTime)}\n`;

            // Add speaker label if:
            // 1. This is the first line of a new speaker
            // 2. This speaker is resuming after another speaker
            if ((segmentIndex === 0 && lineIndex === 0 && speakerChanged) || speakerJustChanged) {
              // Format: "Speaker Name: Text content" instead of using <v> tags
              vttContent += `${segment.speaker_label}: ${line.trim()}\n\n`;
              speakerJustChanged = false;
            } else {
              vttContent += `${line.trim()}\n\n`;
            }

            currentTime = lineEndTime;
          });
        });

        // Mark that the next speaker will be different
        speakerJustChanged = true;
      });

      return vttContent;
    },
    // Function to create Blob URL from VTT content
    async createCaptionTrack({ dispatch }, transcriptionData) {
      const vttContent = await dispatch("convertToWebVTT", transcriptionData);
      const blob = new Blob([vttContent], { type: "text/vtt" });
      return URL.createObjectURL(blob);
    },
    async mountPlayer({ commit, dispatch, state, getters }, params) {
      console.log("mountPlayer", getters.selected_clip);

      $("#dvr-playback-take-video").empty();

      const hideMarkers = params?.hide_markers;

      const media_to_use = getters.selected_clip;

      if (!media_to_use) {
        return;
      }

      let url = media_to_use.playback_url;
      for (let quality of ["/low.mp4", "/medium.mp4", "/high.mp4"]) {
        url = url.replace(quality, ".m3u8");
      }

      let externalTracksToUse = [];
      let pluginsToUse = [];
      if (media_to_use?.transcriptions?.length > 0) {
        pluginsToUse.push(Innoplay.Plugins.ClosedCaptions);
        const captionsUrl = await dispatch("createCaptionTrack", media_to_use?.transcriptions);

        const ccTrack = {
          kind: "captions",
          srclang: "en",
          label: "English",
          src: captionsUrl,
          name: "English",
          default: true,
        };
        externalTracksToUse.push(ccTrack);
      }

      const commentMarkers =
        media_to_use?.logs?.map((log) =>
          Innoplay.Plugins.Markers.StandardMarker.create(log.id, Number(log.timecode_in), log.comment)
        ) || [];

      const _clips = state.media?.trimmed_clips;
      const clipMarkers = [];

      if (_clips && _clips.length > 0) {
        _clips.forEach((clip) => {
          const _markerInfo = clip?.markerInfo;

          if (_markerInfo)
            clipMarkers.push(
              Innoplay.Plugins.Markers.CircleMarker.create(
                "clip:" + _markerInfo.id,
                _markerInfo.start_time,
                _markerInfo.label,
                {
                  color: _markerInfo.color,
                  select_color: _markerInfo.select_color,
                }
              )
            );
        });
      }

      const markersToUse = [...commentMarkers, ...clipMarkers];

      __takePlayer = new Innoplay.Player({
        parentId: "#dvr-playback-take-video",
        source: url,
        poster: media_to_use.thumbnail_url ? media_to_use.thumbnail_url.replace("?width=300", "") : undefined,
        width: "100%",
        height: "100%",
        autoPlay: false,
        mute: false,
        playback: {
          playInline: true,
          crossOrigin: false,
          externalTracks: externalTracksToUse,
        },
        persistConfig: false,
        logBar: {
          placeholder: "Type here to log video",
        },
        hlsUseNextLevel: true,
        hlsPlayback: {
          playInline: true,
          crossOrigin: false,
          preload: true,
        },
        hideMediaControl: false,
        fps: media_to_use?.frame_rate || 30,
        circleMarkerColor: "#FF0338",
        markers: markersToUse,
        onRemoveMarker: function (marker) {
          const log = media_to_use?.logs?.find((l) => l.id === marker.id);
          if (log) {
            commit("DestroyLog", log);
          }
        },
        onSelectMarker: function (marker) {
          if (marker.id.startsWith("clip:")) {
            const clip_id = marker.id.split(":")[1];
            commit("setSelectedClipId", clip_id);
            console.log("Marker selected", marker);
          }
        },
        plugins: pluginsToUse,
        closedCaptionsConfig: {
          defaultLanguage: "en",
          title: "Subtitles",
          ariaLabel: "Closed Captions",
          labelCallback: function (track) {
            return track.name;
          },
        },
      });

      if (hideMarkers) __takePlayer.markers = [];

      __takePlayer.getPlugin(Innoplay.Plugins.LevelSelector.name).disable();
      __takePlayer.getPlugin(Innoplay.Plugins.LogBar.name).disable();

      if (media_to_use?.name?.endsWith(".mp3") || media_to_use?.name?.endsWith(".wav")) {
        console.log("Disabling Aspect Ratio Plugin for Audio");
        __takePlayer.getPlugin(Innoplay.Plugins.Rotate.name).disable();
        __takePlayer.getPlugin(Innoplay.Plugins.AspectRatio.name).disable();
        __takePlayer.getPlugin(Innoplay.Plugins.PlaybackRate.name).disable();
        __takePlayer.getPlugin(Innoplay.Plugins.CameraSwitcher.name).disable();
      }

      // player events
      __takePlayer.on("timeupdate", function (event) {
        $(document).trigger("videoPlayerTimeUpdate", event.current);
      });

      console.log("__takePlayer", __takePlayer);

      commit("setVideoPlayerContainer", __takePlayer);
    },
    /**
     * Destroys the video player instance.
     *
     * @param {Object} commit - The commit object used for Vuex state management.
     * @return {void}
     */
    destroyPlayer({ commit }) {
      if (__takePlayer) {
        __takePlayer.destroy();
        __takePlayer = null;
        commit("show", { body: null });
        commit("removeVideoPlayerContainer");
      }
    },
    seekPlayer({}, time) {
      if (__takePlayer) {
        __takePlayer.seek(time);
      }
    },
    /**
     * Adds a log entry in the player.
     *
     * @param {object} logData - The log data object.
     * @param {object} logData.id - The log ID.
     * @param {number} logData.timecode_in - The timecode in seconds.
     * @param {string} logData.comment - The log comment.
     * @param log
     */
    addLogInPlayer({}, log) {
      if (__takePlayer) {
        __takePlayer
          .getPlugin(Innoplay.Plugins.Markers.name)
          .addMarker(Innoplay.Plugins.Markers.StandardMarker.create(log.id, Number(log.timecode_in), log.comment));
      }
    },
    /**
     * Removes the specified log from the player's marker.
     *
     * @param {Object} __takePlayer - The player object.
     * @param {Object} log - The log object to be removed.
     */
    removeLogInPlayer({}, log) {
      if (__takePlayer) {
        __takePlayer.getPlugin(Innoplay.Plugins.Markers.name).removeMarkerById(log.id);
      }
    },
    // close - this.manageModal();
    // add - this.manageModal("add")
    // edit - this.manageModal("edit")
    // OR edit - this.manageModal({action: "edit", payload: "dad23dg34"})
    manageModal({ commit }, data) {
      commit("modalData", data);
      $("#mediame-modal").modal(data ? "show" : "hide");
    },
    setVisibility({ commit }, data) {
      commit("setVisibility", data);
    },
    updateTranscriptionSegment({ state }, data) {
      const index = state.media.transcriptions.findIndex((el) => el.id === data.id);
      if (index !== -1) {
        state.media.transcriptions.splice(index, 1, data);
      }
    },
    toggleMediaStar({ state }, hashid) {
      const media_item = state.media_list.find((m) => m.hashid === hashid);
      media_item.starred = !media_item.starred;
    },
  },
  getters: {
    visibility: (s) => s.visibility,
    is_connected: (s) => s.is_connected,
    is_new_user: (s) => s.is_new_user,

    modal: (s) => s.modal,
    get_started_actions_performed: (s) => s.get_started_actions_performed,
    get_started_metadata: (s) => s.get_started_metadata,

    media_list: (s) => s.media_list,
    media: (s) => s.media,
    favorites: (s) => s.favorites,
    tags_list: (s) => s.tags_list,
    tags_list_with_id: (s) => s.tags_list_with_id,
    isLoading: (s) => s.isLoading,

    query: (s) => s.query,
    appliedFilter: (s) => s.appliedFilter,
    sort: (s) => s.sort,
    type: (s) => s.type,

    startIndex: (s) => s.startIndex,
    perPage: (s) => s.perPage,
    endIndex: (s) => s.endIndex,
    currentPage: (s) => s.currentPage,
    activeTab: (s) => s.activeTab,

    // for upload modal only
    uploadedFiles: (s) => s.uploadedFiles,
    upload_waitlist: (s) => s.upload_waitlist,
    localStorageFavKey: (s) => s.localStorageFavKey,

    deliver_me_media_list: (s) => s.media_list.filter((v) => v.belongs_to === "deliver_me"),
    direct_me_media_list: (s) => s.media_list.filter((v) => v.belongs_to === "direct_me"),
    media_me_media_list: (s) => s.media_list.filter((v) => v.belongs_to === "media_me"),

    selected_media_list: (s) => s.selectedMedia,
    get_started_current_step: (s) => s.get_started_current_step,
    get_started_selected_preferences: (s) => s.get_started_selected_preferences,
    get_started_selected_preference_categories: (s) => s.get_started_selected_preference_categories,

    videoPlayerTime: (s) => s.videoPlayerTime,

    filesBeingUploaded: (s) => s.filesBeingUploaded,
    video_player_container__clappr: (s) => s.video_player_container__clappr,
    selected_clip_id: (s) => s.selected_clip_id,

    /*       const _selectedClip = clipId === "original" ? this.media : this.clips.find((clip) => clip.hashid === clipId);
     */
    selected_clip: (s) => {
      if (s.selected_clip_id === "original") return s.media;
      return s.media?.trimmed_clips?.find((clip) => clip.hashid === s.selected_clip_id);
    },

    media_list_by_tag: (s) => (tag_id) => {
      return s.media_list.filter((each_media) => {
        const tag_idx = each_media.tag_obj.findIndex(
          (each_media_item_tag) => parseInt(each_media_item_tag.id) === parseInt(tag_id)
        );
        return tag_idx > -1;
      });
    },
    media_list_to_use:
      (s, g) =>
      ({ id, name }) => {
        let items = g.media_list;
        if (name === "mediames.smart-tags.index") items = g.media_list_by_tag(id);
        else if (g.activeTab === "favorites") items = g.favorites;

        return items.filter((item) => {
          if (!item.hashid && item.is_uploading) return true;
          return item.hashid;
        });
      },
    items:
      (s, g, rs, rg) =>
      ({ id, name }) => {
        const searchTerm = g.query.toLowerCase().trim();
        let items = g.media_list_to_use({ id, name })?.slice();
        if (!items) return null;

        if (searchTerm)
          items = items.filter((media) => {
            const nameMatch = media.name?.toLowerCase().includes(searchTerm);
            const tagMatch = media.tag_list?.some((tag) => tag.toLowerCase().includes(searchTerm));
            const descMatch = media.description?.toLowerCase().includes(searchTerm);
            return nameMatch || tagMatch || descMatch;
          });

        if (g.appliedFilter && g.appliedFilter !== "All") {
          items = items.filter((media) => {
            const mediaTags = media.tag_list || [];
            if (["DirectME", "DeliverME", "MediaME"].includes(g.appliedFilter)) {
              return media.belongs_to.toLowerCase() === SOURCE[g.appliedFilter];
            }
            return (
              mediaTags.some((tag) => tag.toLowerCase() === g.appliedFilter.toLowerCase()) ||
              media.type?.toLowerCase() === g.appliedFilter.toLowerCase()
            );
          });
        }
        // Sorting logic based on the sort value
        let type = g.sort;
        items.sort(MEDIAME_SORT_OPTIONS[type].algo);

        //add files from filesBeingUploaded if not already in items, ut only those that belong to current project

        const filesBeingUploaded = g.filesBeingUploaded.filter((f) => {
          return f.project_hashid === rg[`${PROJECT_MODULE_NAME}/selected_project`].project_hashid;
        });

        // put filesBeingUploaded at the beginning of items
        items = [...filesBeingUploaded, ...items];

        const startIndex = (g.currentPage - 1) * g.perPage;
        const endIndex = startIndex + g.perPage - 1;
        items = items.slice(startIndex, endIndex + 1);
        return items;
      },
  },
};

export const mapMediaMEActions = (data) => mapActions(MEDIAME_MODULE_NAME, data);
export const mapMediaMEGetters = (data) => mapGetters(MEDIAME_MODULE_NAME, data);

export const mapMediaMEMutations = (data) => mapMutations(MEDIAME_MODULE_NAME, data);

export default MediaMEModule;

// Helper functions moved outside the mutation for reusability and cleaner scope
const createTimecodeConverter = () => {
  const timeCache = new Map();
  return (tc) => {
    if (!tc) return 0;
    if (timeCache.has(tc)) return timeCache.get(tc);

    // If tc is already a number (float), return it directly
    if (typeof tc === "number") {
      timeCache.set(tc, tc);
      return tc;
    }

    // Otherwise process as timecode string
    const [hh, mm, ss, ff] = tc.split(":").map(Number);
    const seconds = hh * 3600 + mm * 60 + ss + ff / 30;
    timeCache.set(tc, seconds);
    return seconds;
  };
};

const processCaptions = (captions, timecodeToSec) => {
  return captions.map((caption) => ({
    ...caption,
    timeInSeconds: timecodeToSec(caption.st),
  }));
};

const processMainTranscriptions = (transcriptions, captionTimes, timecodeToSec) => {
  return transcriptions.map((transcription) => ({
    ...transcription,
    captions: captionTimes.filter(({ timeInSeconds, st, et, ct, id }) => {
      const segmentStart = timecodeToSec(transcription.start_time);
      const segmentEnd = timecodeToSec(transcription.end_time);
      return timeInSeconds >= segmentStart && timeInSeconds < segmentEnd;
    }),
  }));
};

const processClipTranscriptions = (transcriptions, captionTimes, clipStart, clipEnd, timecodeToSec) => {
  return transcriptions
    .filter((trans) => {
      const transStart = timecodeToSec(trans.start_time);
      const transEnd = timecodeToSec(trans.end_time);
      return transStart <= clipEnd && transEnd > clipStart;
    })
    .map((trans) => {
      const transStart = timecodeToSec(trans.start_time);
      const transEnd = timecodeToSec(trans.end_time);

      return {
        ...trans,
        start_seconds: Math.max(0, transStart - clipStart),
        end_seconds: Math.min(clipEnd - clipStart, transEnd - clipStart),
        captions: filterAndAdjustCaptions(captionTimes, transStart, transEnd, clipStart, clipEnd),
      };
    });
};

const filterAndAdjustCaptions = (captionTimes, transStart, transEnd, clipStart, clipEnd) => {
  return captionTimes
    .filter(
      ({ timeInSeconds }) =>
        timeInSeconds >= transStart && timeInSeconds < transEnd && timeInSeconds >= clipStart && timeInSeconds < clipEnd
    )
    .map((caption) => ({
      ...caption,
      timeInSeconds: caption.timeInSeconds - clipStart,
    }));
};
